import { Box, HStack, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { Drawer, TextLink } from '@time-line/components/common';
import { PersonBioDrawer } from '@time-line/components/drawers';
import { useImage } from 'lib/sanity';
import Image from 'next/image';
import type { Contributor as ContributorProps } from 'types/cms/blog/Contributors';

export const Contributor = ({
  contributor,
}: {
  contributor: ContributorProps;
}) => {
  const {
    contributor: { name, image, role },
  } = contributor;
  const imageProps = useImage(image || null, { ratio: 1 / 1 });
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Stack
        spacing="3xs"
        direction="row"
        position="relative"
        sx={{ img: { boxSize: 'lg' } }}
        alignItems="center"
      >
        <Box width="lg" borderRadius="full" overflow="hidden">
          {imageProps && <Image {...imageProps} alt={name} sizes="40px" />}
        </Box>
        <Stack spacing={0}>
          <HStack spacing="5xs">
            <Text size="detail" fontWeight="medium">
              {contributor.role}
            </Text>
            <TextLink
              as="button"
              variant="underline"
              textProps={{
                size: 'detail',
                fontWeight: 'medium',
              }}
              _after={{
                content: '""',
                position: 'absolute',
                inset: 0,
              }}
              onClick={onOpen}
            >
              {name}
            </TextLink>
          </HStack>
          <Text size="detail" color="blackAlpha.700">
            {role}
          </Text>
        </Stack>
      </Stack>
      <Drawer isOpen={isOpen} onClose={onClose} title="About" subtitle={role}>
        <PersonBioDrawer {...contributor.contributor} />
      </Drawer>
    </>
  );
};
